/**
 * Checks if a message contains "GM" or "good morning" with proper word boundaries.
 * Ensures no false positives from URLs or words containing these strings.
 *
 * @param content - The message content to check
 * @returns true if the message contains a valid GM
 */
export function containsGM(content: string): boolean {
  // Word boundary pattern that matches:
  // - Start of string or whitespace/punctuation before
  // - The target word (case insensitive)
  // - End of string or whitespace/punctuation after
  const gmPattern =
    /(?:^|[\s.,!?;:'"\-—()\[\]{}])(gm|good\s+morning)(?=$|[\s.,!?;:'"\-—()\[\]{}])/i;

  return gmPattern.test(content);
}

/**
 * Validates that a GM message contains "GM" or "good morning" for publishing.
 * Same logic as containsGM but explicitly for validation purposes.
 *
 * @param content - The message content to validate
 * @returns true if the message is a valid GM
 */
export function isValidGMMessage(content: string): boolean {
  return containsGM(content);
}
